angular.module('impactx.smartform').controller('SmartFormViewerTestCtrl', [
    '$scope',
    SmartFormViewerTestController]);

function SmartFormViewerTestController($scope) {
    $scope.formConfig = {
        "identifier": "TestXYZ",
        "title": "E-Mail-Bestellexporter",
        "entries": [
            {
                "id": "debugMail",
                "index": 2,
                "readOnly": false,
                "label": "Debug E-Mail-Adresse",
                "description": "Geben Sie hier eine E-Mail Adresse an, an welche bei Fehlern der Aufgabe eine Nachricht versandt wird",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 2,
                    "row": 0,
                    "column": 2,
                    "readOnly": true
                },
                "component": "textinput",
                "value": "admin@localhost",
                "required": true,
                "type": "email"
            },
            {
                "id": "url",
                "index": 4,
                "readOnly": false,
                "label": "Website",
                "description": "Ihre Homepage",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 2,
                    "row": 1,
                    "column": 2
                },
                "component": "textinput",
                "value": "www.veenion.de",
                "required": false,
                "type": "url"
            },
            {
                "id": "numberOfDebugMessages",
                "index": 6,
                "readOnly": false,
                "label": "Maximale Anzahl Debug Nachrichten",
                "description": "Es werden Ihnen nicht mehr E-Mail zugeschickt wie hier angegeben.",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 2,
                    "row": 2,
                    "column": 2
                },
                "component": "numberinput",
                "value": 3,
                "required": false,
                "onlyNatural": false,
                "zeroAllowed": true,
                "noDecimals": true
            },
            {
                "id": "debugMode",
                "index": 0,
                "readOnly": false,
                "label": "Debugmodus",
                "description": "Gibt zusätzliche Informationen im Log aus.",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 1,
                    "row": 0,
                    "column": 0
                },
                "component": "checkbox",
                "value": true
            },
            {
                "id": "advancedSetting",
                "index": 3,
                "readOnly": false,
                "label": "Erweiterte Einstellungen",
                "description": "Schalte zusätzliche Optionen frei.",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 1,
                    "row": 1,
                    "column": 0
                },
                "component": "checkbox",
                "value": false
            },
            {
                "id": "debugDescription",
                "index": 8,
                "readOnly": false,
                "label": "Beschreibung Debug-Modus",
                "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat, laborum.",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 5,
                    "row": 3,
                    "column": 0,
                    "minSizeY": 5,
                    "maxSizeY": 5
                },
                "component": "textarea",
                "value": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dignissimos esse illo ipsum nobis nostrum odio pariatur quis voluptate. Debitis deserunt, in magni nihil optio pariatur quia reiciendis repellat veritatis voluptate! Accusamus adipisci aspernatur at, consequatur cum deserunt eligendi eveniet fuga, laborum magni nobis obcaecati pariatur perspiciatis praesentium quam rem repellendus.",
                "required": true
            },
            {
                "id": "toppings",
                "index": 7,
                "readOnly": false,
                "label": "Pizzabelag",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 2,
                    "row": 6,
                    "column": 2
                },
                "component": "select",
                "value": {
                    "id": 2,
                    "value": "Käse anstatt Teig",
                    "hash": "89A2A9163EF6"
                },
                "required": false,
                "removeEmptyOption": false,
                "options": [
                    {
                        "value": 0,
                        "label": "Käse"
                    },
                    {
                        "value": 1,
                        "label": "Viel Käse"
                    },
                    {
                        "value": 2,
                        "label": "Käse anstatt Teig"
                    },
                    {
                        "value": 3,
                        "label": "Salami"
                    },
                    {
                        "value": 4,
                        "label": "Lyoner"
                    },
                    {
                        "value": 5,
                        "label": "Ganzer Thunfisch"
                    }
                ]
            },
            {
                "id": "size",
                "index": 5,
                "readOnly": false,
                "label": "Pizzagröße",
                "description": "Wählen Sie hier die gewünschte Größe Ihrer Pizza.",
                "layout": {
                    "sizeX": 2,
                    "sizeY": 5,
                    "row": 10,
                    "column": 0
                },
                "component": "radiogroup",
                "value": 3,
                "options": [
                    {
                        "value": 0,
                        "label": "Klein"
                    },
                    {
                        "value": 1,
                        "label": "Mittel"
                    },
                    {
                        "value": 2,
                        "label": "Groß"
                    },
                    {
                        "value": 3,
                        "label": "Gigantisch"
                    }
                ]
            }
        ],
        "layout": {
            "columns": 4
        }
    }
}